import HomeTitle from "./home/HomeTitle";
import HomeStart from "./home/HomeStart";
import HomeNumber from "./home/HomeNumber";
import HomeDarkAds from "./home/HomeDarkAds";
import HomePricing from "./home/HomePricing";
import HomeFAQ from "./home/HomeFAQ";
import HomePT from './home/HomePT';

export default function HomeView() {
  return (
    <>
      <div>
        <HomeTitle />
      </div>
      <div id="services">
        <HomeStart />
      </div>
      {/*<div id="trainers">*/}
      {/*  <HomePT />*/}
      {/*</div>*/}
      {/*<div id="about">*/}
      {/*  <HomeNumber />*/}
      {/*</div>*/}
      <div id="trainers">
        <HomeDarkAds />
      </div>
      <div id="pricing">
        <HomePricing />
      </div>
      <div id="faq">
        <HomeFAQ />
      </div>
    </>
  )
}
